const CONVERSATION_CLOSED = 'conversation closed';
const CONVERSATION_REOPENED = 'conversation reopened';
const CONVERSATION_ASSIGNED = 'conversation assigned';
const CONVERSATION_RATING_LEFT = 'conversation rating left';
const CONVERSATION_ASSIGNMENT_TYPES = {
  AGENT_ASSIGNED_BY_AGENT: 'agent assigned by agent',
  TEAM_ASSIGNED_BY_AGENT: 'team assigned by agent',
  AGENT_UNASSIGNED_BY_AGENT: 'agent unassigned by agent',
  TEAM_UNASSIGNED_BY_AGENT: 'team unassigned by agent',
  AGENT_ASSIGNED_BY_WORKFLOW: 'agent assigned by workflow',
  TEAM_ASSIGNED_BY_WORKFLOW: 'team assigned by workflow',
  BOT_ASSIGNED_BY_WORKFLOW: 'bot assigned by workflow',
  AGENT_ASSIGNED_BY_BOT: 'agent assigned by bot',
  TEAM_ASSIGNED_BY_BOT: 'team assigned by bot',
  BOT_ASSIGNED_BY_ITSELF: 'bot has been triggered',
  BOT_UNASSIGNED_BY_ITSELF: 'bot unassigned by itself',
  BOT_UNASSIGNED_BY_AGENT: 'bot unassigned by agent',
  AGENT_ASSIGNED_BY_BOT: 'agent assigned by bot',
  TEAM_ASSIGNED_BY_BOT: 'team assigned by bot',
  AGENT_ASSIGNED_BY_BOT_SKILL: 'agent assigned by bot skill',
  TEAM_ASSIGNED_BY_BOT_SKILL: 'team assigned by bot skill',
};

module.exports = {
  CONVERSATION_CLOSED,
  CONVERSATION_REOPENED,
  CONVERSATION_ASSIGNED,
  CONVERSATION_ASSIGNMENT_TYPES,
  CONVERSATION_RATING_LEFT,
};
